export enum DiagnosticAction {
    DIAGNOSTIC_PLUGIN = 'toggleDiagnosticPlugin',
    CONFIG_TO_CLIPBOARD = 'configToClipboard',
    CONFIG_TO_TEST_PAGE = 'configToTestPage',
}